// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__2LsVh","arrowIcon":"DateRangeController_arrowIcon__y1eN-"};